/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import Box from '@material-ui/core/Box';

import SumsubWebSdk from '@sumsub/websdk-react'

import LoadingComponent from 'components/loading';

import RegisterService from 'services/registerService';
import { handleApiFormResponse } from 'lib/forms';

import NotificationHelper from 'lib/notifications';

type SubscriptionTabSumSubComponentProps = {
  activeCompanyId: number;
  successHandler: () => void;
}

type SubscriptionTabSumSubComponentState = {
  isLoading: boolean;
  isProcessing: boolean;
  accessToken: string;
}

class SubscriptionTabSumSubComponent extends React.Component<SubscriptionTabSumSubComponentProps, SubscriptionTabSumSubComponentState> {

  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    try {
      const response = await RegisterService.getKycAccessToken(this.props.activeCompanyId);

      this.setState({
        accessToken: response,
        isLoading: false
      });
    } catch (e) {
      console.error(e);
      NotificationHelper.createNotification(NotificationHelper.TYPE_ERROR);
    }
  }

  submitForm = async () => {
    if (!this.validateDocuments()) return;
    this.setState({ isProcessing: true });

    // add documents
    const addPromises = [];

    // if nothing, do nothing
    if (addPromises.length === 0) {
      this.props.successHandler();
      return;
    }

    try {
      await Promise.all(addPromises);
      this.props.successHandler();
    } catch (e) {
      handleApiFormResponse.call(this, e);
      this.setState({ isProcessing: false });
    }
  }

  accessTokenExpirationHandler = async () => {
    return;
  }

  messageHandler = async (message, payload) => {
    console.log(message);
    console.log(payload);
    if (message == 'idCheck.onApplicantVerificationCompleted' || message == 'idCheck.onApplicantStatusChanged')
    {
      if (payload.reviewStatus == 'completed')
        this.props.successHandler();
    }
    return;
  }

  errorHandler = async () => {
    return;
  }

  render = () => {
    if (this.state.isLoading) return (<LoadingComponent />);
    return (
      <Box height={'40vh'}>
        <SumsubWebSdk
          accessToken={this.state.accessToken}
          expirationHandler={this.accessTokenExpirationHandler}
          config={
            { 'theme': 'light' }
          }
          // options={options}
          onMessage={this.messageHandler}
          onError={this.errorHandler}
        />
      </Box>
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id,
  activeCompanyPersonId: state.auth.user.activeCompany.companyPersonId
});

export default connect(mapStateToProps)(SubscriptionTabSumSubComponent);
